var map = {
	"./ch.js": 70,
	"./de.js": 71,
	"./en.js": 72,
	"./es.js": 73,
	"./fr.js": 74,
	"./it.js": 75,
	"./ja.js": 76,
	"./ko.js": 77,
	"./pl.js": 78,
	"./pt.js": 79,
	"./pt_PT.js": 80,
	"./ru.js": 81,
	"./tr.js": 82,
	"./uk.js": 83
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;